module.exports = __webpack_public_path__ + "static/media/font_bold.ca7bbedf.woff2";